import React from "react";
import { Link } from "react-router-dom";
import labelsData from "../data/labels";

const Home = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Etichette Vini</h1>
      <div style={styles.grid}>
        {Object.entries(labelsData).map(([id, label]) => (
          <Link to={`/labels/${id}`} key={id} style={styles.card}>
            <div style={styles.imageContainer}>
              <img
                src={label.labelImage}
                alt={label.wineName}
                style={styles.image}
              />
            </div>
            <div style={styles.cardContent}>
              <h2 style={styles.wineName}>{label.wineName}</h2>
              <p style={styles.wineType}>{label.wineType}</p>
              <p style={styles.vintage}>Annata: {label.vintage}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: "20px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  title: {
    textAlign: "center",
    color: "#333",
    marginBottom: "40px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
    gap: "30px",
    padding: "20px",
  },
  card: {
    textDecoration: "none",
    color: "inherit",
    backgroundColor: "white",
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    transition: "transform 0.2s, box-shadow 0.2s",
    ":hover": {
      transform: "translateY(-5px)",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    },
  },
  imageContainer: {
    width: "100%",
    height: "300px",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f5f5f5",
  },
  image: {
    width: "auto",
    height: "100%",
    objectFit: "contain",
  },
  cardContent: {
    padding: "20px",
  },
  wineName: {
    margin: "0 0 10px 0",
    fontSize: "1.2em",
    color: "#333",
  },
  wineType: {
    margin: "0 0 5px 0",
    color: "#666",
    fontSize: "0.9em",
  },
  vintage: {
    margin: "0",
    color: "#888",
    fontSize: "0.8em",
  },
};

export default Home;
